module.exports = __webpack_public_path__ + "static/media/responsive-gold-tier-person.366fd879.svg";